export default __webpack_public_path__ + "assets/pdf/Compliance.adb7b04b.pdf";